
// confirmable items are items that require confirmation before adding to cart
// change the text to read "Click again to remove" when clicked
document.addEventListener('click', async function (event) {
    if (event.target.matches('[data-link-type="remove-from-cart"]') || event.target.closest('[data-link-type="remove-from-cart"]') !== null) {
       await handleRemoveFromCart(event);
       return;
    }
});

// listen for form submits
document.addEventListener('submit', async function (event) {
    // if the submit comes from an input.class="cart-item__quantity-input" then we need to update the cart
    if (event.target.matches('#cartform')) {
        // see if one of the inputs has a quantity of zero
        let inputsWithZeroQuantity = Array.from(event.target.querySelectorAll('input.cart-item__quantity-input')).filter(input => input.value === '0');

        if (inputsWithZeroQuantity.length > 0) {
            event.preventDefault();
            // go no further
            return;
            // TODO: make this remove the addon items if this is a parent item
        }
    }
});

async function removeAddonItems(confirmable) {
    // we need to call the cart update url
    const postUrl = window.Shopify.routes.root + 'cart/update.js';
    // generate the update object it looks like
    // updates: {
    //     123456789: 0,
    //     987654321: 0
    // }

    if (confirmable.dataset.addonItemsToRemove === undefined) {
        return true;
    }

    let addonItems = confirmable.dataset.addonItemsToRemove.split(',');
    let updateObject = {};
    for (let i = 0, iLen = addonItems.length; i < iLen; i++) {
        if (addonItems[i] === undefined) continue;
        updateObject[addonItems[i]] = 0;
    }
    const postBody = {
        updates: updateObject,
    }

    // use fetch to post to the url
    const response = await fetch(postUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(postBody),
    });

    // if the response is ok, return true
    if (response.ok) {
       return true;
    }

    // otherwise error and return false
    console.log('Error removing addon items from cart');
    return false;
}

async function handleRemoveFromCart(event) {
    event.preventDefault();

    let confirmable;

    if (event.target.matches('[data-link-type="remove-from-cart"]')) {
        confirmable = event.target;
    } else {
        confirmable = event.target.closest('[data-link-type="remove-from-cart"]');
    }

    if (confirmable === null) {
        return;
    }

    // prepare it ready to confirm
    if (confirmable.dataset.readyToBeConfirmed !== 'true') {
        confirmable.dataset.readyToBeConfirmed = 'true';
        confirmable.innerHTML = confirmable.innerHTML.replace('Remove', 'Click again to remove');
        return;
    }

    // remove from cart
    if (confirmable.dataset.addonItemsToRemove != null && confirmable.dataset.addonItemsToRemove !== '') {
        let removeResult = await removeAddonItems(confirmable);
        // if the remove fails then do not remove the parent
        if (!removeResult) {
            return;
        }
    }

    // remove the parent by visiting the href, this also reloads the page
    window.location.href = confirmable.href;
}
